// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__2iS9w","info":"Panel_info__3eSNH","note":"Panel_note__1bVof","close":"Panel_close__1mq-_","btns":"Panel_btns__36LdD","button":"Panel_button__1BkX-"};